import React from 'react';
import Cart from '../features/cart';

const CartPage = () => {
  return <Cart />;
};

export default CartPage;
